import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { Course } from './../models/course';
import { Rating } from './../models/rating';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class CourseService {
    controller = 'Course';

    constructor(private base: BaseService) { }

    get(id: number): Observable<ApiObjectData> {
        return this.base.get(id, this.controller + '/GetCourseById');
    }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetAllCourses');
    }

    getCourseByTeacherId(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetCourseByTeacherId/' + id)
    }

    getCourseByCategoryId(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetCourseByCategoryId/' + id)
    }

    
    getCourseRating(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetCourseRating/' + id)
    }

    getCoursesByTeacherAndCategoryId(gatId: number, teacherId: number) {
        return this.base.gets(this.controller + '/GetCoursesByTeacherAndCategoryId/'+ gatId +'/' + teacherId)
    }

    
    getALLCourseRating(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetALLCourseRating/' + id)
    }

    save(obj: Course) {
        let token = localStorage.getItem('token');
        let headers = new HttpHeaders().set("Authorization", "Bearer " + token)
        return this.base.saveWithToken(this.controller + '/CreateCourse',obj, {headers});
        // return this.base.save(this.controller + '/CreateCourse', obj);
    }

    rateCourse(obj: Rating) {
        return this.base.save(this.controller + '/RateCourse', obj);
    }

    getTopRatedCourses(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetTopRatedCourses');
    }

    getPagedCourses(page: number, pageSize: number) {
        return this.base.gets(this.controller + '/GetPagedCourses/' + page + '/' + pageSize);
    }

    getCoursesCount(){
        return this.base.gets(this.controller + '/GetCoursesCount');
    }

    Search(text: string): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/Search?searchInput='+text)
    }

    searchCoursesByTeacherId(searchInput: string, id: number) {
        return this.base.gets(this.controller + '/SearchCoursesByTeacherId/' + 'searchInput=' + searchInput + '/' + id);
    }

    searchCoursesForStudentId(studentId: number, searchInput: string) {
        return this.base.gets(this.controller + '/SearchCoursesForStudentId' + 'searchInput=' + searchInput + '/' + studentId);
    }

    getDashBoard() {
        return this.base.gets(this.controller + '/GetDashBoard')
    }

    delete(courseId: number, userId: number, academyToken: string) {
        return this.base.delteCourse(this.controller, courseId, userId, academyToken)
    }
}